import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { login } from "../redux/authSlice/authSlice";
import { jwtDecode } from "jwt-decode";

// console.log(decoded);

const PrivateRoute = ({ children, roles }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get("token");
    
    // console.log("decoed",decoded);
    
    
    if (urlToken && !isAuthenticated) {
      const decoded = jwtDecode(urlToken);
      
      sessionStorage.setItem("accessToken", urlToken);
      sessionStorage.setItem("role", decoded?.role);
      sessionStorage.setItem("user_id", decoded?.user_id);
      sessionStorage.setItem("access_type", decoded?.access_type);
      sessionStorage.setItem("name", decoded?.division_name);
      sessionStorage.setItem("location", decoded?.unit_location);


      const userData = {
        id: decoded.user_id || 1,
        name: "External User",
        role: decoded?.role,
        email: decoded?.email,
      };

      dispatch(login({ user: userData }));

      // Remove token from URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    setCheckingAuth(false);
  }, [dispatch]);

  // ⏳ Wait until external check finishes
  if (checkingAuth) {
    return null; // or loader
  }

  // 🔐 Not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 🔐 Role check
  if (roles && !roles.includes(user?.role?.toLowerCase())) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PrivateRoute;
